import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Footer from 'src/components/Footer';
import MapEmbed from 'src/components/MapEmbed';
import Navbar from 'src/components/Navbar';
import ServicesSection from 'src/components/ServicesSection';
import Sidebar from 'src/components/Sidebar';
import { Colors, LoadIcon } from 'src/styles/DesignSystem';
import FormContato from './FormContato';

const Contato = () => {
    // Controles do menu
    const [isOpen, setIsOpen] = useState(false);
    const toggle = ()=>{
        setIsOpen(!isOpen);
    }

    // Fetch Data from API
    const [data, setData] = useState({});
    const [servicos, setServicos] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);

    // Controle de Requisições
    const servicosEndP = 'https://hipermercadodasracoes.com/system/wp-json/wp/v2/servicos';
    const sobreEndP = 'https://hipermercadodasracoes.com/system/wp-json/wp/v2/sobre';

    const servicosRequest = axios.get(servicosEndP);
    const sobreRequest = axios.get(sobreEndP);

    useEffect(() => {
        const fetching = () => {
            axios.all([servicosRequest, sobreRequest]).then(axios.spread((...responses) => {
                setServicos(responses[0].data);
                setData(responses[1].data[0]);
                setIsLoaded(true);
                // use/access the results 
            })).catch(errors => {
                // react on errors.
            })
        };
        fetching();
    }, []);


    if(!isLoaded){
        return(
          <>
            <LoadIcon />
          </>
        )
    }
    return (
        <>
            <Navbar isOpen = {isOpen} toggle={toggle} page="contato"/>
            <Sidebar isOpen = {isOpen} toggle={toggle} page='contato'/>

            <FormContato />
            <MapEmbed />

            <Footer 
                bgColor={Colors.lighBrown}
                firtsComponent={
                    <ServicesSection 
                        title="Conheça nossos serviços"
                        titleColor={Colors.lighBrown}
                        padding={10}
                        services={servicos}
                    />
                }
            />
        </>
    )
}

export default Contato;